import { forwardRef, type SVGProps } from "react";
import { createLucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

//Convert svg to lucide data icons using: https://studio.lucide.dev/
export const Upload = createLucideIcon("upload", [
  [
    "path",
    {
      d: "M12 4v12",
      key: "fcvml1",
    },
  ],
  [
    "path",
    {
      d: "M16.5 7.5S13.186 3 12 3 7.5 7.5 7.5 7.5",
      key: "7rjbus",
    },
  ],
  [
    "path",
    {
      d: "M3 17c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.121 2.122C5.605 21 6.07 21 7 21h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17",
      key: "hrv0t3",
    },
  ],
]);

export const TrashBin = createLucideIcon("trashbin", [
  [
    "path",
    {
      d: "M14.5 16.5v-6",
      key: "1iktyz",
    },
  ],
  [
    "path",
    {
      d: "m16.056 5.5-.683-1.408c-.453-.936-.68-1.403-1.071-1.695a2 2 0 0 0-.275-.172C13.594 2 13.074 2 12.035 2c-1.066 0-1.599 0-2.04.234a2 2 0 0 0-.278.18c-.395.303-.616.788-1.058 1.757L8.053 5.5",
      key: "hw6qsj",
    },
  ],
  [
    "path",
    {
      d: "m19.5 5.5-.62 10.025c-.158 2.561-.237 3.842-.88 4.763a4 4 0 0 1-1.2 1.128c-.957.584-2.24.584-4.806.584-2.57 0-3.855 0-4.814-.585a4 4 0 0 1-1.2-1.13c-.642-.922-.72-2.205-.874-4.77L4.5 5.5",
      key: "1wgo7s",
    },
  ],
  [
    "path",
    {
      d: "M3 5.5h18",
      key: "1hki23",
    },
  ],
  [
    "path",
    {
      d: "M9.5 16.5v-6",
      key: "1yjfc9",
    },
  ],
]);

export const LoaderCircle = createLucideIcon("loader-circle", [
  [
    "path",
    {
      d: "M21 12a9 9 0 1 1-6.219-8.559",
      key: "1ml4ps",
    },
  ],
]);

export const PlusCircleFilled = createLucideIcon("plus-circle-filled", [
  [
    "circle",
    {
      cx: "11.992",
      cy: "12",
      r: "10",
      fill: "currentColor",
      stroke: "none",
      key: "1qfcfy",
    },
  ],
  [
    "path",
    {
      d: "M11.992 8v8",
      fill: "none",
      stroke: "var(--color-blue-600)",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "18x6yk",
    },
  ],
  [
    "path",
    {
      d: "M15.992 12h-8",
      fill: "none",
      stroke: "var(--color-blue-600)",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "tcrk41",
    },
  ],
]);

export const ChevronUpDown = createLucideIcon("chevron-up-down", [
  [
    "path",
    {
      d: "M8.25 15 12 18.75 15.75 15",
      key: "1wx8jj",
    },
  ],
  [
    "path",
    {
      d: "M8.25 9 12 5.25 15.75 9",
      key: "1yvrej",
    },
  ],
]);

export const CheckCircle = createLucideIcon("check-circle", [
  [
    "path",
    {
      d: "m8 12.5 2.5 2.5L16 9",
      key: "1bd3ep",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
]);

export const ClockFading = createLucideIcon("clock-fading", [
  [
    "path",
    {
      d: "M15 2a9.5 9.5 0 0 1 1.413.547",
      key: "jctkjk",
    },
  ],
  [
    "path",
    {
      d: "M16 12h-4V6",
      key: "16ooyd",
    },
  ],
  [
    "path",
    {
      d: "M18.848 4.17a11 11 0 0 1 .985.986",
      key: "1pxtq2",
    },
  ],
  [
    "path",
    {
      d: "M21.438 7.555A9.5 9.5 0 0 1 22 9",
      key: "5mvdz4",
    },
  ],
  [
    "path",
    {
      d: "M22 12A10 10 0 1 1 12 2",
      key: "1fm58d",
    },
  ],
]);

export const AlertCircle = createLucideIcon("alert-circle", [
  [
    "path",
    {
      d: "M12 15.988h.01",
      key: "1pqhu8",
    },
  ],
  [
    "path",
    {
      d: "M12 8v4.5",
      key: "1tqxbk",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
]);

export const Workspace = createLucideIcon("workspace", [
  [
    "path",
    {
      d: "M10.5 6.75c0-1.644 0-2.466-.454-3.019a2 2 0 0 0-.277-.277C9.216 3 8.394 3 6.75 3s-2.466 0-3.019.454a2 2 0 0 0-.277.277C3 4.284 3 5.106 3 6.75v2c0 1.644 0 2.466.454 3.019a2 2 0 0 0 .277.277c.553.454 1.375.454 3.019.454s2.466 0 3.019-.454a2 2 0 0 0 .277-.277c.454-.553.454-1.375.454-3.019z",
      key: "3yn9nv",
    },
  ],
  [
    "path",
    {
      d: "M16.25 3c-.698 0-1.047 0-1.33.086a2 2 0 0 0-1.334 1.333c-.086.284-.086.633-.086 1.331s0 1.047.086 1.33a2 2 0 0 0 1.333 1.334c.284.086.633.086 1.331.086h2c.698 0 1.047 0 1.33-.086a2 2 0 0 0 1.334-1.333C21 6.797 21 6.448 21 5.75s0-1.047-.086-1.33a2 2 0 0 0-1.333-1.334C19.297 3 18.948 3 18.25 3z",
      key: "1866hx",
    },
  ],
  [
    "path",
    {
      d: "M21 15.25c0-1.644 0-2.466-.454-3.019a2 2 0 0 0-.277-.277c-.553-.454-1.375-.454-3.019-.454s-2.466 0-3.019.454a2 2 0 0 0-.277.277c-.454.553-.454 1.375-.454 3.019v2c0 1.644 0 2.466.454 3.019a2 2 0 0 0 .277.277c.553.454 1.375.454 3.019.454s2.466 0 3.019-.454a2 2 0 0 0 .277-.277C21 19.716 21 18.894 21 17.25z",
      key: "5dktb6",
    },
  ],
  [
    "path",
    {
      d: "M5.75 15.5c-.698 0-1.047 0-1.33.086a2 2 0 0 0-1.334 1.333C3 17.203 3 17.552 3 18.25s0 1.047.086 1.33a2 2 0 0 0 1.333 1.334C4.703 21 5.052 21 5.75 21h2c.698 0 1.047 0 1.33-.086a2 2 0 0 0 1.334-1.333c.086-.284.086-.633.086-1.331s0-1.047-.086-1.33a2 2 0 0 0-1.333-1.334c-.284-.086-.633-.086-1.331-.086z",
      key: "11xj54",
    },
  ],
]);

export const Building = createLucideIcon("building", [
  [
    "path",
    {
      d: "M10.5 11H9.5",
      key: "1f4ffu",
    },
  ],
  [
    "path",
    {
      d: "M10.5 15H9.5",
      key: "ng8fb7",
    },
  ],
  [
    "path",
    {
      d: "M10.5 7H9.5",
      key: "gkvn74",
    },
  ],
  [
    "path",
    {
      d: "M14 22V8C14 5.17157 14 3.75736 13.1213 2.87868C12.2426 2 10.8284 2 8 2C5.17157 2 3.75736 2 2.87868 2.87868C2 3.75736 2 5.17157 2 8V16C2 18.8284 2 20.2426 2.87868 21.1213C3.75736 22 5.17157 22 8 22H14Z",
      key: "3gs1je",
    },
  ],
  [
    "path",
    {
      d: "M18 8H14V22H18C19.8856 22 20.8284 22 21.4142 21.4142C22 20.8284 22 19.8856 22 18V12C22 10.1144 22 9.17157 21.4142 8.58579C20.8284 8 19.8856 8 18 8Z",
      key: "1ldkpt",
    },
  ],
  [
    "path",
    {
      d: "M18.5 11H17.5",
      key: "1pj4wt",
    },
  ],
  [
    "path",
    {
      d: "M18.5 15H17.5",
      key: "i67vec",
    },
  ],
  [
    "path",
    {
      d: "M6.5 11H5.5",
      key: "1fqvbf",
    },
  ],
  [
    "path",
    {
      d: "M6.5 15H5.5",
      key: "5jlu3c",
    },
  ],
  [
    "path",
    {
      d: "M6.5 7H5.5",
      key: "8a0uob",
    },
  ],
]);

export const Bell = createLucideIcon("bell", [
  [
    "path",
    {
      d: "M12 20v1.5",
      key: "yk9gqy",
    },
  ],
  [
    "path",
    {
      d: "M13.5 20a1 1 0 0 1-3 0",
      key: "s06seq",
    },
  ],
  [
    "path",
    {
      d: "M19 18V9.5a7 7 0 0 0-14 0V18",
      key: "isxp10",
    },
  ],
  [
    "path",
    {
      d: "M20.5 18h-17",
      key: "pkrm5g",
    },
  ],
]);

export const Plus = createLucideIcon("plus", [
  [
    "path",
    {
      d: "M12.001 5v14.002",
      key: "11gziz",
    },
  ],
  [
    "path",
    {
      d: "M19.002 12.002H5",
      key: "37bv7l",
    },
  ],
]);

export const X = createLucideIcon("x", [
  [
    "path",
    {
      d: "M18 18 6 6",
      key: "16p8oy",
    },
  ],
  [
    "path",
    {
      d: "M18 6 6 18",
      key: "1bl5f8",
    },
  ],
]);

export const Home = createLucideIcon("home", [
  [
    "path",
    {
      d: "M15 21.5v-5c0-1.414 0-2.121-.44-2.56-.439-.44-1.146-.44-2.56-.44s-2.121 0-2.56.44C9 14.378 9 15.085 9 16.5v5",
      key: "13ke1p",
    },
  ],
  [
    "path",
    {
      d: "M3 14.5c0 3.3 0 4.95 1.025 5.975S6.7 21.5 10 21.5h4c3.3 0 4.95 0 5.975-1.025S21 17.8 21 14.5v-2.51c0-1.682 0-2.522-.356-3.25s-1.02-1.244-2.346-2.276l-2-1.555C14.233 3.303 13.2 2.5 12 2.5s-2.233.803-4.298 2.409l-2 1.555C4.375 7.496 3.712 8.012 3.356 8.74S3 10.308 3 11.99z",
      key: "bsuc8e",
    },
  ],
]);

export const Rocket = createLucideIcon("rocket", [
  [
    "path",
    {
      d: "M13.295 5.004c1.672-1.673 3.862-2.367 6.18-2.48.901-.044 1.352-.066 1.713.295.362.362.34.812.296 1.714-.114 2.318-.807 4.507-2.48 6.18L17.518 12.2c-1.223 1.223-1.57 1.571-1.314 2.898.253 1.014.499 1.995-.238 2.732-.894.895-1.71.895-2.604 0l-7.184-7.183c-.894-.894-.894-1.71 0-2.604.737-.737 1.72-.492 2.733-.238 1.327.257 1.675-.091 2.898-1.315z",
      key: "1merm3",
    },
  ],
  [
    "path",
    {
      d: "M16.992 7h.01",
      key: "pli7gc",
    },
  ],
  [
    "path",
    {
      d: "m2.508 15.5 2-2",
      key: "1xs6f3",
    },
  ],
  [
    "path",
    {
      d: "m2.508 21.5 5-5",
      key: "7xbd8j",
    },
  ],
  [
    "path",
    {
      d: "m8.508 21.5 2-2",
      key: "17w15c",
    },
  ],
]);

export const Graph = createLucideIcon("graph", [
  [
    "path",
    {
      d: "M15.434 14.296 18 9",
      key: "1j5zkl",
    },
  ],
  [
    "path",
    {
      d: "M19.992 21h-11c-3.3 0-4.95 0-5.975-1.025S1.992 17.3 1.992 14V3",
      key: "rhwrge",
    },
  ],
  [
    "path",
    {
      d: "m3 19 4.59-7.12",
      key: "2zr6el",
    },
  ],
  [
    "path",
    {
      d: "m9.583 11.568 3.62 2.728",
      key: "umscs3",
    },
  ],
  [
    "circle",
    {
      cx: "14.508",
      cy: "15.5",
      r: "1.5",
      key: "1c5etv",
    },
  ],
  [
    "circle",
    {
      cx: "18.492",
      cy: "7.5",
      r: "1.5",
      key: "15kbuc",
    },
  ],
  [
    "circle",
    {
      cx: "8.508",
      cy: "10.5",
      r: "1.5",
      key: "zn1qnd",
    },
  ],
]);

export const People = createLucideIcon("people", [
  [
    "path",
    {
      d: "M10.286 14A4.286 4.286 0 0 0 6 18.286 1.714 1.714 0 0 0 7.714 20h8.572A1.714 1.714 0 0 0 18 18.286 4.286 4.286 0 0 0 13.714 14z",
      key: "14raoy",
    },
  ],
  [
    "path",
    {
      d: "M16.008 4a3 3 0 0 1 1.218 5.742",
      key: "10o0rg",
    },
  ],
  [
    "path",
    {
      d: "M17.719 13a4.286 4.286 0 0 1 4.285 4.286A1.714 1.714 0 0 1 20.29 19",
      key: "1a8fyf",
    },
  ],
  [
    "path",
    {
      d: "M3.707 19a1.714 1.714 0 0 1-1.715-1.714A4.286 4.286 0 0 1 6.278 13",
      key: "1r9ccp",
    },
  ],
  [
    "path",
    {
      d: "M7.992 4a3 3 0 0 0-1.218 5.742",
      key: "1sge17",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "8",
      r: "3",
      key: "154z85",
    },
  ],
]);

export const Location = createLucideIcon("location", [
  [
    "path",
    {
      d: "M15.716 8.33c.943.935-.566 8.533-2.114 8.667-1.299.112-1.703-2.45-1.977-3.26-.27-.802-.57-1.09-1.364-1.353-2.019-.668-3.028-1.002-3.228-1.53-.53-1.4 7.478-3.717 8.683-2.523",
      key: "930h86",
    },
  ],
  [
    "circle",
    {
      cx: "11.992",
      cy: "12",
      r: "10",
      key: "1qfcfy",
    },
  ],
]);

export const Pixels = createLucideIcon("pixels", [
  [
    "path",
    {
      d: "M1.5 12h4.2",
      key: "1uzdqc",
    },
  ],
  [
    "path",
    {
      d: "M12 1.5v4.2",
      key: "qpwn0g",
    },
  ],
  [
    "path",
    {
      d: "M12 18.3v4.2",
      key: "9fdpoe",
    },
  ],
  [
    "path",
    {
      d: "m16.41 16.41 3.045 3.045",
      key: "88esk7",
    },
  ],
  [
    "path",
    {
      d: "m16.41 7.59 3.045-3.045",
      key: "1xucgp",
    },
  ],
  [
    "path",
    {
      d: "M18.3 12h4.2",
      key: "1190o5",
    },
  ],
  [
    "path",
    {
      d: "M4.545 19.455 7.59 16.41",
      key: "1sj1hh",
    },
  ],
  [
    "path",
    {
      d: "M4.545 4.545 7.59 7.59",
      key: "dru61j",
    },
  ],
]);

export const Tag = createLucideIcon("tag", [
  [
    "path",
    {
      d: "M6.235 4c-2.44 0-3.66 0-4.09.766l-.038.071c-.388.789.303 1.794 1.686 3.805 1.103 1.604 1.655 2.406 1.668 3.313v.09c-.013.907-.565 1.709-1.668 3.313-1.383 2.01-2.074 3.016-1.686 3.804l.037.071c.43.767 1.65.767 4.09.767H13c1.963 0 2.944 0 3.789-.422.844-.423 1.433-1.208 2.611-2.778 1.733-2.311 2.6-3.467 2.6-4.8 0-1.334-.867-2.49-2.6-4.8-1.178-1.57-1.767-2.356-2.611-2.778S14.963 4 13 4z",
      key: "1k207w",
    },
  ],
]);

export const Expand = createLucideIcon("expand", [
  [
    "path",
    {
      d: "m13.98 14.002 6.548 6.496",
      key: "h5ij35",
    },
  ],
  [
    "path",
    {
      d: "m14.01 9.999 6.053-6.052",
      key: "1usq8m",
    },
  ],
  [
    "path",
    {
      d: "M16 20.902s3.966.356 4.612-.29.29-4.612.29-4.612",
      key: "1q4vad",
    },
  ],
  [
    "path",
    {
      d: "M16 3.098s3.966-.356 4.612.29.29 4.612.29 4.612",
      key: "bzd1aq",
    },
  ],
  [
    "path",
    {
      d: "M8 20.902s-3.966.356-4.612-.29S3.098 16 3.098 16",
      key: "1yz5cn",
    },
  ],
  [
    "path",
    {
      d: "M8 3.098s-3.966-.356-4.612.29S3.098 8 3.098 8",
      key: "1qw2rj",
    },
  ],
  [
    "path",
    {
      d: "M9.997 10.002 3.846 3.86",
      key: "1n5bd6",
    },
  ],
  [
    "path",
    {
      d: "M9.997 14.002 3.64 20.381",
      key: "12m56j",
    },
  ],
]);

export const ExternalLink = createLucideIcon("external-link", [
  [
    "path",
    {
      d: "M11.1 3c-3.65.007-5.56.096-6.782 1.318C3 5.636 3 7.757 3 12c0 4.242 0 6.364 1.318 7.682S7.757 21 12 21s6.363 0 7.68-1.318c1.222-1.221 1.312-3.133 1.318-6.782",
      key: "kcroa0",
    },
  ],
  [
    "path",
    {
      d: "m20.556 3.496-9.507 9.563",
      key: "1owfb8",
    },
  ],
  [
    "path",
    {
      d: "M20.994 8.027c.01-.704.056-4.036-.438-4.53s-3.822-.45-4.525-.44",
      key: "1fo2n4",
    },
  ],
]);

export const Author = createLucideIcon("author", [
  [
    "path",
    {
      d: "M17 17a5 5 0 0 0-10 0",
      key: "1u12ck",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "9",
      r: "3",
      key: "1cxyma",
    },
  ],
]);

export const Google = createLucideIcon("google", [
  [
    "path",
    {
      d: "M1.287 6.621a11.85 11.85 0 0 0 0 10.757A998 998 0 0 0 5.28 14.28a7.2 7.2 0 0 1 0-4.56z",
      key: "1lfuwa",
    },
  ],
  [
    "path",
    {
      d: "M12 9.817v4.648h6.458a5.53 5.53 0 0 1-2.41 3.61l3.894 3.022c2.269-2.094 3.578-5.17 3.578-8.825a14 14 0 0 0-.218-2.454z",
      key: "pa5urc",
    },
  ],
  [
    "path",
    {
      d: "M5.274 14.284c.955 2.843 3.605 4.949 6.725 4.949 1.615 0 2.978-.437 4.048-1.157l3.894 3.022C17.956 22.93 15.239 24 11.999 24c-4.69 0-8.738-2.706-10.712-6.622z",
      key: "1h5hpk",
    },
  ],
  [
    "path",
    {
      d: "M5.28 9.72c.949-2.836 3.6-4.942 6.72-4.942 1.767 0 3.338.611 4.593 1.79l3.436-3.437C17.945 1.189 15.239 0 11.999 0 7.31 0 3.263 2.695 1.288 6.622",
      key: "1ez7dy",
    },
  ],
]);

/** Matches design system Icon/Info (public/images/icons/info.svg, viewBox 0 0 17 17). */
export const Info = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function Info({ className, ...props }, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("shrink-0", className)}
        aria-hidden
        {...props}
      >
        <path
          d="M8.25016 15.1663C11.9321 15.1663 14.9168 12.1816 14.9168 8.49967C14.9168 4.81778 11.9321 1.83301 8.25016 1.83301C4.56826 1.83301 1.5835 4.81778 1.5835 8.49967C1.5835 12.1816 4.56826 15.1663 8.25016 15.1663Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 11.167V8.16699"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 5.84163V5.83496"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
Info.displayName = "Info";

/** Matches design system Icon/Dollar2 (Figma), viewBox 0 0 16 16. */
export const Dollar2 = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function Dollar2({ className, ...props }, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("size-4 shrink-0", className)}
        aria-hidden
        {...props}
      >
        <g transform="translate(4 1.333) scale(0.914)">
          <path
            d="M5.83333 11.1667C8.77887 11.1667 11.1667 8.77887 11.1667 5.83333C11.1667 2.88781 8.77887 0.5 5.83333 0.5C2.88781 0.5 0.5 2.88781 0.5 5.83333C0.5 8.77887 2.88781 11.1667 5.83333 11.1667Z"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </g>
        <g transform="translate(1.333 7.333) scale(0.88)">
          <path
            d="M1.27105 0.500057C0.783487 1.24512 0.5 2.13572 0.5 3.09259C0.5 5.71086 2.62252 7.83339 5.24077 7.83339C6.19767 7.83339 7.08827 7.54992 7.83333 7.06232"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </g>
        <g transform="translate(8 4)">
          <path
            d="M3.01287 1.96735C2.86874 1.35927 2.13514 0.810553 1.25454 1.22105C0.373937 1.63155 0.23407 2.95232 1.56607 3.09263C2.16814 3.15605 2.5606 3.01904 2.92 3.40659C3.27934 3.79413 3.34614 4.87186 2.42747 5.16233C1.5088 5.45279 0.599137 4.99893 0.50007 4.35453M1.82287 0.5V1.07936M1.82287 5.25173V5.83333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  },
);
Dollar2.displayName = "Dollar2";

export const Lightbulb = createLucideIcon("lightbulb", [
  [
    "path",
    {
      d: "M5.731 13.333C5.067 12.274 4.686 11.033 4.686 9.706C4.686 5.818 7.96 2.667 12 2.667C16.04 2.667 19.314 5.818 19.314 9.706C19.314 11.033 18.933 12.274 18.269 13.333",
      key: "lb-bulb",
    },
  ],
  [
    "path",
    {
      d: "M8.013 17.232C7.934 17.048 7.894 16.956 7.898 16.881C7.908 16.723 8.037 16.584 8.228 16.527C8.318 16.5 8.443 16.5 8.694 16.5H15.307C15.558 16.5 15.683 16.5 15.773 16.527C15.963 16.584 16.093 16.723 16.102 16.881C16.107 16.956 16.067 17.048 15.988 17.232C15.841 17.573 15.768 17.743 15.655 17.881C15.418 18.17 15.047 18.378 14.618 18.461C14.413 18.5 14.181 18.5 13.717 18.5H10.283C9.82 18.5 9.588 18.5 9.383 18.461C8.954 18.378 8.583 18.17 8.346 17.881C8.233 17.743 8.16 17.573 8.013 17.232Z",
      key: "lb-base",
    },
  ],
  [
    "path",
    {
      d: "M14.409 19.113L14.306 19.611C14.192 20.155 14.135 20.427 14.008 20.643C13.811 20.975 13.492 21.225 13.114 21.345C12.869 21.423 12.579 21.423 12 21.423C11.421 21.423 11.131 21.423 10.886 21.345C10.508 21.225 10.189 20.975 9.992 20.643C9.865 20.427 9.808 20.155 9.695 19.611L9.591 19.113",
      key: "lb-cap",
    },
  ],
  [
    "path",
    {
      d: "M12.324 7.077L11.429 8.38C11.306 8.559 11.381 8.846 11.562 8.889L12.438 9.097C12.631 9.143 12.699 9.459 12.552 9.629L11.442 10.923",
      key: "lb-bolt",
    },
  ],
]);

export const CSV = createLucideIcon("csv", [
  [
    "path",
    {
      d: "M12.876 16h-1.18c-.473 0-.709 0-.895.076-.634.26-.625.869-.625 1.424s-.009 1.165.625 1.424c.186.076.422.076.894.076s.708 0 .894.076c.634.26.625.869.625 1.424s.009 1.165-.625 1.424c-.186.076-.422.076-.894.076H10.41",
      key: "5yf5et",
    },
  ],
  [
    "path",
    {
      d: "M13 2.5V3c0 2.828 0 4.243.879 5.121C14.757 9 16.172 9 19 9h.5",
      key: "aq4lhk",
    },
  ],
  [
    "path",
    {
      d: "M20 13v-2.343c0-.818 0-1.226-.152-1.594s-.441-.657-1.02-1.235l-4.736-4.736c-.499-.499-.748-.748-1.058-.896a2 2 0 0 0-.197-.082C12.514 2 12.161 2 11.456 2c-3.245 0-4.868 0-5.967.886a4 4 0 0 0-.603.603C4 4.59 4 6.211 4 9.456V13",
      key: "16wwue",
    },
  ],
  [
    "path",
    {
      d: "m20.5 16-1.777 4.695c-.33.87-.494 1.305-.755 1.305-.26 0-.426-.435-.755-1.305L15.436 16",
      key: "8fyyuu",
    },
  ],
  [
    "path",
    {
      d: "M7.5 17.22C7.445 16.03 6.622 16 5.505 16c-1.72 0-2.005.406-2.005 2v2c0 1.594.285 2 2.005 2 1.117 0 1.94-.03 1.995-1.22",
      key: "ep5jqb",
    },
  ],
]);

export const Circle = createLucideIcon("circle", [
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
]);

export const Mail = createLucideIcon("mail", [
  [
    "path",
    {
      d: "m2 6 6.913 3.917c2.549 1.444 3.625 1.444 6.174 0L22 6",
      key: "1g9kjj",
    },
  ],
  [
    "path",
    {
      d: "M2.016 13.476c.065 3.065.098 4.598 1.229 5.733 1.131 1.136 2.705 1.175 5.854 1.254a115 115 0 0 0 5.802 0c3.149-.079 4.723-.118 5.854-1.254 1.131-1.135 1.164-2.668 1.23-5.733a69 69 0 0 0 0-2.952c-.066-3.065-.099-4.598-1.23-5.733-1.131-1.136-2.705-1.175-5.854-1.254a115 115 0 0 0-5.802 0c-3.149.079-4.723.118-5.854 1.254-1.131 1.135-1.164 2.668-1.23 5.733a69 69 0 0 0 0 2.952",
      key: "1wp1j0",
    },
  ],
]);

export const ArrowRight = createLucideIcon("arrow-right", [
  [
    "path",
    {
      d: "M15 17s5-3.682 5-5-5-5-5-5",
      key: "7c7kky",
    },
  ],
  [
    "path",
    {
      d: "M20 12H4",
      key: "1mtusc",
    },
  ],
]);

export const ArrowLeft = createLucideIcon("arrow-left", [
  [
    "path",
    {
      d: "M4 12h16",
      key: "1lakjw",
    },
  ],
  [
    "path",
    {
      d: "M9 17s-5-3.682-5-5 5-5 5-5",
      key: "1ump00",
    },
  ],
]);

export const Search = createLucideIcon("search", [
  [
    "path",
    {
      d: "m17 17 4 4",
      key: "1b3523",
    },
  ],
  [
    "circle",
    {
      cx: "11",
      cy: "11",
      r: "8",
      key: "4ej97u",
    },
  ],
]);

export const QuestionMark = createLucideIcon("question-mark", [
  [
    "path",
    {
      d: "M12 17h.01",
      key: "p32p05",
    },
  ],
  [
    "path",
    {
      d: "M9.5 9.5a2.5 2.5 0 1 1 3.912 2.064C12.728 12.032 12 12.672 12 13.5",
      key: "14pxm7",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
]);

export const TrendUp = createLucideIcon("trend-up", [
  [
    "path",
    {
      d: "M20 13V8h-5",
      key: "1wmbte",
    },
  ],
  [
    "path",
    {
      d: "m20 8-5 5c-.883.883-1.324 1.324-1.865 1.373a1.5 1.5 0 0 1-.27 0c-.541-.05-.982-.49-1.865-1.373s-1.324-1.324-1.865-1.373a1.5 1.5 0 0 0-.27 0c-.541.05-.982.49-1.865 1.373l-3 3",
      key: "agmt0w",
    },
  ],
]);

export const TrendDown = createLucideIcon("trend-down", [
  [
    "path",
    {
      d: "M20 11v5h-5",
      key: "e84q9y",
    },
  ],
  [
    "path",
    {
      d: "m20 16-5-5c-.883-.883-1.324-1.324-1.865-1.373a1.5 1.5 0 0 0-.27 0c-.541.05-.982.49-1.865 1.373s-1.324 1.324-1.865 1.373a1.5 1.5 0 0 1-.27 0c-.541-.05-.982-.49-1.865-1.373L4 8",
      key: "z3kqge",
    },
  ],
]);

export const CheckCircleFilled = createLucideIcon("check-circle-filled", [
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      fill: "currentColor",
      stroke: "none",
      key: "1v35n8",
    },
  ],
  [
    "path",
    {
      d: "m8 12.5 2.5 2.5L16 9",
      fill: "none",
      stroke: "#fff",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "1jdxtq",
    },
  ],
]);

export const UploadFolder = createLucideIcon("upload-folder", [
  [
    "path",
    {
      d: "M10 21.5c-3.287 0-4.931 0-6.038-.908a4 4 0 0 1-.554-.554C2.5 18.93 2.5 17.288 2.5 14c0-3.287 0-4.931.908-6.038a4 4 0 0 1 .554-.554C5.07 6.5 6.712 6.5 10 6.5h4c3.287 0 4.931 0 6.038.908a4 4 0 0 1 .554.554c.908 1.107.908 2.75.908 6.038s0 4.931-.908 6.038a4 4 0 0 1-.554.554c-1.107.908-2.75.908-6.038.908z",
      key: "qr1iqq",
    },
  ],
  [
    "path",
    {
      d: "M12 11v6.5",
      key: "2htzrj",
    },
  ],
  [
    "path",
    {
      d: "M15 13.5s-2.21-3-3-3-3 3-3 3",
      key: "aj33qt",
    },
  ],
  [
    "path",
    {
      d: "M2.5 14.5v-4c0-3.771 0-5.657 1.172-6.828S6.729 2.5 10.5 2.5h3c3.771 0 5.657 0 6.828 1.172S21.5 6.729 21.5 10.5v4",
      key: "1umzbr",
    },
  ],
]);

export const CancelCircle = createLucideIcon("cancel-circle", [
  [
    "path",
    {
      d: "M15 15 9 9",
      key: "qb9ybb",
    },
  ],
  [
    "path",
    {
      d: "m9 15 6-6",
      key: "1ygkhp",
    },
  ],
  [
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "10",
      key: "1mglay",
    },
  ],
]);

export const Refresh = createLucideIcon("refresh", [
  [
    "path",
    {
      d: "M18.5 3S21 4.841 21 5.5 18.5 8 18.5 8",
      key: "1q0ddz",
    },
  ],
  [
    "path",
    {
      d: "M20.5 5.5h-11C5.787 5.5 3 8.185 3 12",
      key: "u3zzgi",
    },
  ],
  [
    "path",
    {
      d: "M3.5 18.5h11c3.713 0 6.5-2.685 6.5-6.5",
      key: "arer84",
    },
  ],
  [
    "path",
    {
      d: "M5.5 16S3 17.841 3 18.5 5.5 21 5.5 21",
      key: "11wf08",
    },
  ],
]);

export const Admin = createLucideIcon("admin", [
  [
    "path",
    {
      d: "M16.237 15.674v-1.422a1 1 0 0 1 3.505 0v1.422",
      key: "1usjpl",
    },
  ],
  [
    "path",
    {
      d: "M2.502 20a7 7 0 0 1 11-5.745",
      key: "ce9eb2",
    },
  ],
  [
    "circle",
    {
      cx: "9.502",
      cy: "8",
      r: "5",
      key: "16e8q7",
    },
  ],
  [
    "rect",
    {
      x: "14.502",
      y: "15.893",
      width: "6.996",
      height: "5.107",
      rx: "1.803",
      key: "18bbmq",
    },
  ],
]);
